import type { Settings } from '../store/settings';

/** Local-date key "YYYY-MM-DD" (not UTC). */
export function dateKey(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function addDays(d: Date, n: number): Date {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

export function startOfWeek(d: Date, weekStartsOn: 0 | 1): Date {
  const r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  const diff = (r.getDay() - weekStartsOn + 7) % 7;
  return addDays(r, -diff);
}

export interface CalendarRange {
  /** First local day shown. */
  first: Date;
  /** Number of days shown. */
  days: number;
}

/** The days a calendar view covers: list = today + N days; month = whole weeks covering the month. */
export function calendarRange(
  view: Settings['calendar']['view'],
  listDays: number,
  weekStartsOn: 0 | 1,
  now = new Date(),
): CalendarRange {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  switch (view) {
    case 'day':
      return { first: today, days: 1 };
    case 'week':
      return { first: startOfWeek(today, weekStartsOn), days: 7 };
    case 'month': {
      const first = startOfWeek(new Date(now.getFullYear(), now.getMonth(), 1), weekStartsOn);
      const last = new Date(now.getFullYear(), now.getMonth() + 1, 0);
      const weeks = Math.ceil((Math.round((last.getTime() - first.getTime()) / 86_400_000) + 1) / 7);
      return { first, days: weeks * 7 };
    }
    default:
      return { first: today, days: listDays };
  }
}
